import classNames from 'classnames';
import type { ReactNode } from 'react';

export const BrowserNavbar = ({
  children,
  size,
  shouldAddRightPadding,
}: {
  children: ReactNode;
  size?: string;
  shouldAddRightPadding: boolean;
}) => {
  return (
    <nav
      className={classNames(
        'flex items-center relative z-200 bg-ds-natural-600 pl-5',
        size ?? 'h-ds-15',
        { 'pr-5': shouldAddRightPadding }
      )}
    >
      {children}
    </nav>
  );
};
